// extracted by mini-css-extract-plugin
module.exports = {"button":"_1oHwA","secondary":"_2Ebxh","light":"_185p0","cancel":"_3BJrD","block":"_6MTpl"};